import { useEffect, useState, useMemo, useRef } from "react";
import {
  Container,
  ContainerView,
  ContainerRow,
} from "../../../components/Container";
import { Form } from "antd";
import { useApp } from "../../../contexts";
import { InfoTooltipIcon } from "../../../pages/Home/styles";
import { Tooltip } from "antd";
import NumberFormat from "react-number-format";

import {
  errorView,
  formatCurrency,
  getWalletListSgt,
  withdrawSgtRequest,
  withdrawSgtSendCode,
  getWithdrawSGTFee,
  getAddressBookList,
  withdrawSgtSendConfirm,
} from "../../../services/app";
import produce from "immer";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../../components/Layout";
import { WithdrawFormContainer } from "../styles";
import {
  Body,
  FormButton2,
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
} from "./styles";

import {
  FormInputNumberRaw,
  FormItemRow,
  FormSelect,
} from "../../../components/Form";
import { AIAIcon } from "../../../components/Icons/AIAIcon";
import { error, success } from "../../../Notification";
import { isAddress, truncateAddress } from "../../../utils/helper";
import { PolygonIcon } from "../../../components/Icons/PolygonIcon";
import { useWindowSize } from "../../../hook/useWindowSize";
import WithdrawSelectAddress from "../../../components/AddressBooking/WithdrawSelectAddress";
import { ModalAdd } from "../../../components/AddressBooking/ModalAdd";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../../utils/Currency";
import { useVerificationMethod } from "../../../components/ModalVerificationMethod/useVerificationMethod";

export default function WithDrawSGT(props) {
  const { T, loading, setLoading, getCurrency } = useApp();
  const size = useWindowSize();
  const [searchParams, setSearchParams] = useSearchParams();
  const [requestId, setRequestId] = useState(null);
  useEffect(() => {
    if (searchParams.get("requestId")) {
      setRequestId(searchParams.get("requestId"));
    }
  }, [searchParams]);

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  useEffect(() => {
    if (searchParams.get("formData")) {
      const data = JSON.parse(searchParams.get("formData"));
      setFormData(data);
    }
  }, [searchParams]);

  const [available, setAvailable] = useState(false);
  const [showWalletAddress, setShowWalletAddress] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [addressAdd, setAddressAdd] = useState("");
  const [openAdd, setOpenAdd] = useState(false);
  const selectRef = useRef(null);

  const navigate = useNavigate();
  let { code, type } = props || {};

  if (!code && searchParams.get("code")) {
    code = searchParams.get("code");
  }

  const [step, setStep] = useState(1);
  useEffect(() => {
    const stepParam = searchParams.get("step");
    if (stepParam) {
      const stepValue = parseInt(stepParam, 10);
      if (!isNaN(stepValue)) {
        setStep(stepValue);
      } else {
        setStep(1);
      }
    } else {
      setStep(1);
    }
  }, [searchParams]);

  const [isDisabled, setIsDisabled] = useState(false);
  const [fee, setFee] = useState(0);
  const [showPaste, $showPaste] = useState(true);

  const [wallet, setWallet] = useState({});
  const [errors, setErrors] = useState([]);

  const loadFee = async (amount) => {
    let result = await getWithdrawSGTFee(amount);
    if (result?.status === 200) {
      setFee(result?.data?.data || 0);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onSubmitForm = async (values) => {
    try {
      setLoading(true);
      const result = await withdrawSgtRequest(values);
      if (result.status === 200) {
        setRequestId(result?.data?.data?.id);
        setSearchParams(
          (searchParams) => {
            searchParams.set("step", 2);
            searchParams.set("formData", JSON.stringify(values));
            searchParams.set("requestId", result?.data?.data?.id);
            return searchParams;
          },
          {
            replace: true,
          }
        );
        setFormData(values);
        scrollToTop();
      } else {
        setErrors(result?.data?.error?.validates || []);
      }
    } catch (err) {
      error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setIsDisabled(loading);
  }, [loading]);

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    if (values.amount > 0) {
      loadFee(values.amount);
    }
    if (values.walletAddressType === 2) {
      setShowWalletAddress(true);
    } else {
      setShowWalletAddress(false);
      form.setFieldsValue({ walletAddress: "" });
    }
    if (values.walletAddress) {
      $showPaste(false);
    } else {
      $showPaste(true);
    }
    setAvailable(
      (values?.walletAddressType == 1 ||
        (values?.walletAddressType == 2 &&
          values.walletAddress &&
          isAddress(values.walletAddress))) &&
        values.amount >= 10
    );
  };

  useEffect(() => {
    loadData();
    form.setFieldsValue({
      walletAddressType: 1,
    });
  }, []);

  const loadData = async () => {
    setLoading(true);
    let result = await getWalletListSgt();
    if (result.status === 200) {
      const item = result?.data?.data || {};
      setWallet(item);
    }
    setLoading(false);
  };

  const currentWallet = useMemo(() => {
    return wallet;
  }, [wallet]);

  const onTransactionHistory = () => {
    navigate(`/wallet-detail/gameCurrencySGT?code=SGT`);
  };

  const handleStep = (value) => {
    if (value === 2) {
      setSearchParams(
        (searchParams) => {
          searchParams.set("step", value - 1);
          return searchParams;
        },
        {
          replace: true,
        }
      );
    } else {
      navigate(-1);
    }
  };

  const verification = useVerificationMethod();
  useEffect(() => {
    if (searchParams.get("line_connected")) {
      onConfirm({
        chooseMethod: true,
      });
      setSearchParams(
        (searchParams) => {
          searchParams.delete("line_connected");
          return searchParams;
        },
        {
          replace: true,
        }
      );
    }
  }, [searchParams]);

  const onConfirm = async (options = {}) => {
    verification.verify({
      actionText: T("Withdraw"),
      skipTwoFa: true,
      chooseMethod: options?.chooseMethod,
      sendOtp: async (method) => {
        try {
          setLoading(true);
          const res = await withdrawSgtSendCode({
            transactionId: `${requestId}`,
            otp_method: method,
          });
          return {
            success: res.status === 200,
            message:
              res.data?.error?.message ??
              T("Something went wrong! Please try again later!"),
          };
        } catch (error) {
          console.error("Error sending OTP:", error);
          return {
            success: false,
            message:
              error?.response?.data?.error?.message ??
              T("Something went wrong! Please try again later!"),
          };
        } finally {
          setLoading(false);
        }
      },
      action: (method, otp) => {
        return submit(otp);
      },
    });
  };

  const submit = async (otp) => {
    try {
      setLoading(true);
      const result = await withdrawSgtSendConfirm({
        transactionId: `${requestId}`,
        walletAddressType: formData.walletAddressType,
        walletAddress:
          formData?.walletAddressType === 1 ? null : formData?.walletAddress,
        verificationCode: otp,
      });
      if (result.status === 200) {
        success(
          T(
            "Your withdraw request has been created and under processing. Please check your transaction history."
          )
        );
        onTransactionHistory();
        return {
          success: true,
        };
      } else {
        setErrors(result?.data?.error?.validates || []);
        const validates = result?.data?.error?.validates ?? [];
        if (validates.some((item) => item.key === "verificationCode")) {
          return {
            success: false,
            otpError:
              result?.data?.error?.message ?? T("Invalid verification code."),
          };
        } else {
          error(T("Failed to create your request. Please try again later."));
          setSearchParams(
            (searchParams) => {
              searchParams.set("step", 1);
              searchParams.delete("requestId");
              searchParams.delete("formData");
              return searchParams;
            },
            {
              replace: true,
            }
          );
          return {
            success: false,
            otpError:
              result?.data?.error?.message ??
              T("Failed to create your request. Please try again later."),
            close: true,
          };
        }
      }
    } catch (err) {
      const validates = err?.response?.data?.error?.validates ?? [];
      if (validates.some((item) => item.key === "verificationCode")) {
        return {
          success: false,
          otpError:
            err?.response?.data?.error?.message ??
            T("Invalid verification code."),
        };
      } else {
        error(T("Failed to create your request. Please try again later."));
        setSearchParams(
          (searchParams) => {
            searchParams.set("step", 1);
            searchParams.delete("requestId");
            searchParams.delete("formData");
            return searchParams;
          },
          {
            replace: true,
          }
        );
        return {
          success: false,
          otpError:
            err?.response?.data?.error?.message ??
            T("Failed to create your request. Please try again later."),
          close: true,
        };
      }
    } finally {
      setLoading(false);
    }
  };

  const initAddressOptions = () => {
    getAddressBookList({
      keyword: "",
      network: "polygon",
      limit: 500,
    }).then((res) => {
      const options = (res?.data?.data?.rows || []).map((item) => ({
        value: item.address,
        label: item.name,
      }));
      setAddressOptions(options);
    });
  };
  useEffect(() => {
    initAddressOptions();
  }, []);

  return currentWallet ? (
    <Container>
      <ContainerView>
        <TitleWithBack
          title={step === 1 ? T("Claim request") : T("Withdraw Confirmation")}
          onClick={() => handleStep(step)}
        />
        <WithdrawFormContainer>
          <Body className="form">
            {step === 1 ? (
              <>
                <div className="flex flex-col gap-1 mb-5">
                  <div className="text-[15px] text-[#818181] leading-6">
                    {T("Credit")}
                  </div>
                  <div className="bg-[#D9D9D9] lg:bg-[#F5F5F5] rounded-[10px] h-[50px] px-5 flex items-center justify-start gap-2">
                    <img
                      alt=""
                      style={{ width: 28, height: 28 }}
                      src={`/assets/images/otc/crypto/sgt.svg`}
                    />
                    <div className="text-black text-base">
                      {T("SGT (SGT Walk - to - earn)")}
                    </div>
                  </div>
                </div>
                <Form
                  form={form}
                  onFinish={() => {
                    onSubmitForm(form.getFieldsValue());
                  }}
                  onValuesChange={() => onUpdateData()}
                >
                  <FormItemRow
                    name={"walletAddressType"}
                    label={T("Recipient’s address")}
                    className={"input-row-mint no-after column-reserved"}
                    rules={[
                      {
                        required: true,
                        message: T("Recipient’s address is required!"),
                      },
                    ]}
                    extra={
                      <div className="flex justify-start items-start lg:items-center gap-2 mb-3">
                        <div className="note-icon w-[20px] h-[20px] mt-2 lg:mt-0">
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={"/assets/images/alert.svg"}
                            alt=""
                            className="object-contain"
                          />
                        </div>
                        <div
                          className="flex-1 text-[13px]"
                          dangerouslySetInnerHTML={{
                            __html: T("withdraw.alert_pol"),
                          }}
                        ></div>
                      </div>
                    }
                  >
                    <FormSelect className="input-mint">
                      <FormSelect.Option
                        value={1}
                        className={"min-h-[45px] items-center"}
                      >
                        <div className="flex justify-start space-x-[6px] items-center">
                          <span className="w-[24px] h-[24px]">
                            <AIAIcon />
                          </span>
                          <span className="truncate">
                            {T("AI Avatar Web3 Wallet Address")}
                          </span>
                        </div>
                      </FormSelect.Option>
                      <FormSelect.Option
                        value={2}
                        className={"min-h-[45px] items-center"}
                      >
                        <div className="flex justify-start space-x-[6px] items-center">
                          <span className="truncate">
                            {T("Another Web3 Wallet Address")}
                          </span>
                        </div>
                      </FormSelect.Option>
                    </FormSelect>
                  </FormItemRow>
                  {showWalletAddress ? (
                    <div className="relative">
                      <FormItemRow
                        {...errorView(errors, "walletAddress")}
                        className="no-after option-token-row"
                        name={"walletAddress"}
                        label={T("Your Web3 Wallet Address")}
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  new Error(
                                    T("Your Web3 Wallet Address is required")
                                  )
                                );
                              }
                              if (!isAddress(value)) {
                                return Promise.reject(
                                  new Error(
                                    T(
                                      "Invalid Web3 Wallet Address. Please input another address."
                                    )
                                  )
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <WithdrawSelectAddress
                          options={addressOptions}
                          ref={selectRef}
                          value={formData.to}
                          placeholder={T("Please enter Web3 Wallet Address")}
                          className="input-mint"
                          onAddAddress={(address) => {
                            setOpenAdd(true);
                            setAddressAdd(address);
                          }}
                          onChange={() => {
                            setErrors(
                              produce((draft) => {
                                draft.splice(
                                  draft.findIndex(
                                    (item) => item.key === "walletAddress"
                                  ),
                                  1
                                );
                              })
                            );
                          }}
                        />
                      </FormItemRow>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="flex flex-col gap-1 mb-5 ">
                    <div className="text-[15px] text-[#818181] leading-6">
                      {T("Network")}
                    </div>
                    <div className="bg-[#D9D9D9] lg:bg-[#F5F5F5] rounded-[10px] h-[50px] px-5 flex items-center justify-start gap-2">
                      <PolygonIcon />
                      <div className="text-black text-base">
                        {T("Polygon Main Network")}
                      </div>
                    </div>
                  </div>
                  <FormItemRow
                    {...errorView(errors, "amount")}
                    className="no-after option-token-row"
                    name={"amount"}
                    label={T("Withdrawn amount")}
                    rules={[
                      {
                        required: true,
                        message: T("Withdrawn amount is required!"),
                      },
                      {
                        validator: (_, value) => {
                          if (value && value < 10) {
                            return Promise.reject(
                              new Error(T("Withdraw minimum 10 SGT."))
                            );
                          }
                          if (value && value > wallet?.dogFood) {
                            return Promise.reject(
                              new Error(T("Insufficient balance"))
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <FormInputNumberRaw
                      onChange={() => {
                        setErrors(
                          produce((draft) => {
                            draft.splice(
                              draft.findIndex((item) => item.key === "amount"),
                              1
                            );
                          })
                        );
                      }}
                      min={0}
                      onAll={() => {
                        form.setFieldValue(
                          "amount",
                          parseFloat(wallet?.dogFood)
                        );
                        setErrors(
                          produce((draft) => {
                            draft.splice(
                              draft.findIndex((item) => item.key === "amount"),
                              1
                            );
                          })
                        );
                        form.validateFields(["amount"]);
                        onUpdateData();
                      }}
                      addonAfter={wallet?.currencyCode || ""}
                      placeholder={T(`Please enter withdrawal amount`)}
                    />
                  </FormItemRow>

                  <ContainerRow style={{ marginTop: 24, marginBottom: 24 }}>
                    <WalletConvertInfo style={{ flex: 1 }}>
                      <WalletConvertInfoItem>
                        <WalletConvertInfoItemTitle>
                          {T("Balance")}
                          <Tooltip
                            trigger={size.width < 1023 ? "click" : "hover"}
                            onClick={(e) => e.stopPropagation()}
                            className="cursor-pointer"
                            color={"#EAF2FF"}
                            placement={size.width < 1023 ? "bottom" : "top"}
                            overlayClassName={"note-tooltip-10 text-left"}
                            title={
                              <div>
                                <div style={{ marginBottom: "5px" }}>
                                  {T(
                                    "You can withdraw the amount earned from walking."
                                  )}
                                </div>
                              </div>
                            }
                          >
                            <span className="ml-[10px]">
                              <InfoTooltipIcon />
                            </span>
                          </Tooltip>
                        </WalletConvertInfoItemTitle>
                        <WalletConvertInfoItemValue className={"text-aia-red"}>
                          {formatCurrency(
                            wallet?.dogFood || 0,
                            null,
                            getCurrency()
                          )}{" "}
                          {wallet?.currencyCode}
                        </WalletConvertInfoItemValue>
                      </WalletConvertInfoItem>
                      <WalletConvertInfoItem>
                        <WalletConvertInfoItemTitle>
                          {T("Fee")}
                        </WalletConvertInfoItemTitle>
                        <WalletConvertInfoItemValue>
                          {formatCurrency(fee, null, getCurrency())}{" "}
                          {wallet?.currencyCode}
                        </WalletConvertInfoItemValue>
                      </WalletConvertInfoItem>
                    </WalletConvertInfo>
                  </ContainerRow>

                  <div>
                    <FormButton2
                      disabled={!available}
                      htmlType={"button"}
                      onClick={() => {
                        form.submit();
                      }}
                    >
                      {T("Withdraw")}
                    </FormButton2>
                  </div>
                </Form>
              </>
            ) : (
              <>
                <div className="lg:px-3 flex flex-col gap-4">
                  <div className="row-item-sot">
                    <div className="text-[#818181] font-semibold font-base ">
                      {T("Recipient’s Address")}
                    </div>
                    <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                      {formData?.walletAddressType === 1 ? (
                        <>
                          <AIAIcon />{" "}
                          <span className="">
                            {T("AI Avatar Web3 Wallet Address")}
                          </span>
                        </>
                      ) : (
                        <>
                          <span>
                            {truncateAddress(formData.walletAddress, {
                              nPrefix: 16,
                              nSuffix: 5,
                            })}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="row-item-sot">
                    <div className="text-[#818181] font-semibold font-base ">
                      {T("Network")}
                    </div>
                    <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                      <PolygonIcon />
                      <div className="text-black text-base">
                        {T("Polygon Main Network")}
                      </div>
                    </div>
                  </div>
                  <div className="row-item-sot">
                    <div className="text-[#818181] font-semibold font-base ">
                      {T("Credit")}
                    </div>
                    <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-2">
                      <img
                        alt=""
                        style={{ width: 24, height: 24 }}
                        src={`/assets/images/otc/crypto/sgt.svg`}
                      />
                      <div className="text-black text-base">
                        {T("SGT (SGT Walk - to - earn)")}
                      </div>
                    </div>
                  </div>
                  <div className="row-item-sot">
                    <div className="text-[#818181] font-semibold font-base ">
                      {T("Withdrawn amount")}
                    </div>
                    <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-2">
                      <NumberFormat
                        value={formData?.amount}
                        displayType={"text"}
                        suffix=" SGT"
                        thousandSeparator={thousandSeparatorByCurrency(
                          getCurrency()
                        )}
                        decimalSeparator={decimalSeparatorByCurrency(
                          getCurrency()
                        )}
                        decimalScale={8}
                      />
                    </div>
                  </div>
                  <div className="row-item-sot">
                    <div className="text-[#818181] font-semibold font-base">
                      {T("Fee")}
                    </div>
                    <div className="text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                      <NumberFormat
                        value={Number(fee)}
                        displayType={"text"}
                        suffix=" SGT"
                        thousandSeparator={thousandSeparatorByCurrency(
                          getCurrency()
                        )}
                        decimalSeparator={decimalSeparatorByCurrency(
                          getCurrency()
                        )}
                        decimalScale={8}
                      />
                    </div>
                  </div>
                </div>
                <ContainerRow className="mt-4">
                  <FormButton2
                    disabled={isDisabled || loading || verification.loading}
                    className={"lg:ml-3 ml-0"}
                    onClick={() => onConfirm()}
                  >
                    {T("Confirm")}
                  </FormButton2>
                </ContainerRow>
              </>
            )}
          </Body>
        </WithdrawFormContainer>
      </ContainerView>
      {openAdd && (
        <ModalAdd
          title={"Add new address"}
          onSubmit={(address) => {
            setOpenAdd(false);
            form.setFieldValue("walletAddress", address);
            initAddressOptions();
            setTimeout(() => {
              onUpdateData();
            }, [200]);
          }}
          isWithdraw={true}
          defaultAddress={addressAdd}
          defaultNetwork={"polygon"}
          onClose={() => setOpenAdd(false)}
        />
      )}
    </Container>
  ) : null;
}
